import { render, staticRenderFns } from "./SpeakerProfile.vue?vue&type=template&id=49f4ffe5&scoped=true&"
import script from "./SpeakerProfile.vue?vue&type=script&lang=js&"
export * from "./SpeakerProfile.vue?vue&type=script&lang=js&"
import style0 from "./SpeakerProfile.vue?vue&type=style&index=0&id=49f4ffe5&lang=scss&scoped=true&"
import style1 from "./SpeakerProfile.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f4ffe5",
  null
  
)

export default component.exports